export default "__VITE_ASSET__DxORIbQG__"